<script setup>
import { inject } from 'vue'

const props = defineProps({
  quote: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: false
  },
  image: {
    type: String,
    required: false
  }
})

const emit = defineEmits(['click'])

const t = inject('t')
</script>

<template>
  <section class="teaser">
    <div class="header" :style="'background-image: url(' + image + ')'"></div>

    <section class="teaser-content">
      <p class="quote">{{ quote }}</p>
      <p class="text">{{ text }}</p>

      <button @click="emit('click')" class="button">
        <span>
          {{ t('teaser-lohnletter-button') }}
        </span>
        <svg
          data-v-72a9a2a9=""
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            data-v-72a9a2a9=""
            d="M37.958 26.395L26.9893 37.364L16.0204 26.395"
            stroke="#e2001a"
            stroke-width="3.04252"
          ></path>
          <line
            data-v-72a9a2a9=""
            x1="26.9817"
            y1="35.7695"
            x2="26.9817"
            y2="16.7395"
            stroke="#e2001a"
            stroke-width="3.04252"
          ></line>
        </svg>
      </button>
    </section>
  </section>
</template>

<style scoped>
.teaser {
  background: var(--color-grey);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  padding: 3rem 0rem;
  gap: 2rem;
  margin-bottom: 0rem;
  margin-left: calc(-1 * var(--container-padding) / 2);
  margin-right: calc(-1 * var(--container-padding) / 2);
  border-radius: 0 0 14px 14px;
  margin-top: -1rem;
  z-index: 0;
  padding-left: calc(var(--container-padding) / 2);
  padding-right: calc(var(--container-padding) / 2);
  padding-top: 5rem;
  padding-bottom: 5rem;
  text-align: center;
}

.teaser .button {
  align-self: center;
}

.header {
  flex: 0 1 30%;
}

.header {
  flex: 1 1 auto;
  min-width: 170px;
  max-width: 300px;
}

.teaser {
  align-items: center;
  flex-wrap: wrap;
}

.teaser .button {
  width: min(100%, 380px);
}

.teaser .button {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  justify-content: space-between;
  background: var(--color-signal);
  border-radius: 67px;
  color: white;
  font-weight: bold;
  padding: 0px 17px;
  border-width: 4px;
  border: solid 10px var(--color-signal);
  height: 60px;
  transition: all 200ms;
  max-width: 100%;
  box-sizing: border-box;
  font-size: var(--font-size);
  cursor: pointer;
}

.teaser svg {
  background: var(--color-grey);
  transform: rotateZ(-90deg);
  border-radius: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  margin-right: -17px;
  height: 44px;
  width: 44px;
}

.header {
  aspect-ratio: 1;
  background-position: center;
  background-size: cover;
  border-radius: 100%;
  grid-area: header;
  flex: 1 1 20%;
}

.quote {
  font-family: 'Bradford';
  font-style: italic;
  font-weight: 500;
  color: var(--color-signal);
  font-size: 3rem;
  line-height: 51px;
  margin-bottom: 0;
}

.teaser p.text {
  margin-bottom: 3rem;
  font-size: var(--font-size);
  color: var(--color-text);
}

.teaser-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.teaser-content {
  flex: 2 1;
  min-width: min(350px, 100%);
}
</style>
